// Module
var code = `<div class="withdrawal-screen">
    <div class="withdrawal-screen-selector">
        <div class="withdrawal-screen-selector-content">
            <terceraLabel text="{{.fromAccount}}" />
            <terceraLabel text="{{.asset}}" visible="{{.hasAssets}}" />
            <terceraLabel text="{{.avaliable}}" />
            <terceraLabel text="{{.amount}}" />
            <terceraLabel text="{{.remains}}" />
            <terceraLabel visible="{{.hasFee}}" text="{{.feeTitleLabel}}" />
            <terceraLabel visible="{{.hasFee}}" text="{{.requiredAmountTitleLabel}}" />
        </div>

        <div class="withdrawal-screen-selector-content values">
            {{#if !.singleAccount}}
            <terceraLabel text="{{.userLogin}}" />
            {{/if}}
            <accountSelector selectedItem="{{.accountItem}}" visible="{{.singleAccount}}" ignoreForceLinkingByAccount="true" onlyOwnAccounts="true" />
            <terceraLabel text="{{.avaliableValueText}}" />
            <terceraNumeric tradingNumeric="true" value="{{.amountValue}}" minValue="{{minValue}}" maxValue="{{maxValue}}" step="{{step}}" decimalPrecision="{{decimalPrecision}}" />
            <terceraNumeric tradingNumeric="true" value="{{.remainsValue}}" minValue="{{minValue}}" maxValue="{{maxValue}}" step="{{step}}" decimalPrecision="{{decimalPrecision}}" />
            <terceraLabel visible="{{.hasFee}}" text="{{.feeText}}" />
            <terceraLabel visible="{{.hasFee}}" text="{{.requiredAmountText}}" />
        </div>
    </div>

    <div class="withdrawal-screen-footer">
        <terceraButton terceraButtonStyle="{{.btnOKStyle}}" text="{{.okText}}" enabled="{{.amountValue!==0 && .enoughAmount && .canWithdrawal}}" on-btnClick="okClick" />
        <terceraButton terceraButtonStyle="{{.btnCancelStyle}}" text="{{.cancelText}}" on-btnClick="cancelClick" />
    </div>
</div>`;
// Exports
export default code;